// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3187d70a5c5361c3cfd5fdee78bb444133a9cb21.chunk.js";
};